module.exports = __webpack_public_path__ + "media/images/giphy_attribution_white-f5893fa19b487d103c3b55d8ec03b185.png";